import { i18n } from '@lt/localization';
import React from 'react';
import OrderError from 'src/components/OrderError';

type Props = {
  isOpen: boolean;
  errorMessage?: string;
  orderId: number | null;
  onClose: () => void;
  goToOrder: () => void;
};

const CertificateErrorPopup = ({
  isOpen,
  errorMessage,
  orderId,
  onClose,
  goToOrder,
}: Props) => (
  <OrderError
    orderNumber={orderId || undefined}
    title={
      orderId
        ? i18n.t('checkout.error.writeOff')
        : i18n.t('commonPages.order.error')
    }
    message={errorMessage ?? ''}
    isOpened={isOpen}
    closePopup={onClose}
    onRetry={onClose}
    goToOrder={orderId ? goToOrder : undefined}
    contactPhone="+7 495 134-44-11"
  />
);

export default CertificateErrorPopup;
